var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var View = function View(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 17 12' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'view'
      ),
      React.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M16.49 6.143C16.39 5.933 14 1 8.5 1S.61 5.933.51 6.143l-.078.165.078.164c.1.21 2.49 5.143 7.99 5.143s7.89-4.933 7.99-5.143l.078-.164-.078-.165zM8.5 10.769c-4.336 0-6.58-3.637-7.034-4.462.451-.826 2.687-4.46 7.034-4.46 4.336 0 6.58 3.636 7.034 4.46-.451.827-2.687 4.462-7.034 4.462z'
        }),
        React.createElement('path', { d: 'M8.5 3.77c-1.562 0-2.833 1.138-2.833 2.538S6.937 8.846 8.5 8.846c1.562 0 2.833-1.139 2.833-2.538 0-1.4-1.27-2.539-2.833-2.539zM8.5 8c-1.042 0-1.889-.76-1.889-1.692 0-.934.847-1.692 1.889-1.692s1.889.758 1.889 1.692C10.389 7.24 9.542 8 8.5 8z'
        })
      )
    )
  );
};
/*eslint-enable */

export default View;
//# sourceMappingURL=View.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/View.js